import { NavItem } from "reactstrap";
import { Link } from "react-router-dom";
import { NavClassProp } from "../../../../types/Applications";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setActiveTab } from "../../../../reduxToolkit/reducers/taskSlice";
import { TaskTagDataList } from "../../../../data/applications/Task";
import { Href } from "../../../../constants";

const TaskTagData:React.FC<NavClassProp> = ({ activeToggle }) => {
  
  const dispatch = useAppDispatch();
  const { activeTab } = useAppSelector((state) => state.task);
  const tabHandler = (tab: string) => {
    dispatch(setActiveTab(tab));
    activeToggle(tab);
  };

  return (
    <>
      {TaskTagDataList.map((item) => (
        <NavItem key={item.id}>
          <Link to={Href} className={activeTab === item.activeTab ? "show" : ""} onClick={() => tabHandler(item.activeTab)}>
            <span className="title"> {item.title}</span>
          </Link>
        </NavItem>
      ))}
    </>
  );
};
export default TaskTagData;